import React, { useState } from 'react';
import { FaCar, FaChevronRight } from 'react-icons/fa';
import { allCars } from '../components/carData';
import CarCard from './CarCard';
import { Link } from 'react-router-dom';

const categories = ["Popular Car", "Luxury Car", "Vintage Car", "Family Car", "Off-road Car"];

const CarListings = () => {
  const [selectedCategory, setSelectedCategory] = useState("Popular Car");

  const filteredCars = allCars.filter(car => {
    if (selectedCategory === "Popular Car") return true;
    if (selectedCategory === "Luxury Car" && (car.type === "Sedan" || car.type === "Coupé")) return true;
    if (selectedCategory === "Vintage Car" && car.type === "Sport") return true;
    if (selectedCategory === "Family Car" && (car.type === "SUV" || car.type === "Van")) return true;
    if (selectedCategory === "Off-road Car" && car.type === "Truck") return true;
    return false;
  }).slice(0, 6);

  return (
    // Updated: Background is now a light gray color
    <section className="bg-gray-400 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {/* Updated: Header text is now black */}
          <h2 className="text-3xl font-bold text-black mb-2">
            Our Impressive Collection of Cars
          </h2>
          {/* Updated: Paragraph text is now a darker gray */}
          <p className="text-gray-700 max-w-2xl mx-auto">
            Ranging from elegant sedans to powerful sports cars, all carefully selected to provide our
            customers with the ultimate driving experience.
          </p>
        </div>

        {/* Updated: Filter Bar colors */}
        <div className="flex flex-wrap justify-center space-x-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-semibold transition-colors duration-300 ${
                selectedCategory === category
                  ? "bg-black text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredCars.map((car) => (
             <CarCard 
              key={car.id}
              id={car.id}
              name={car.name} 
              type={car.type} 
              price={car.price} 
              image={car.image} 
              specs={car.specs}
            />
          ))}
        </div>

        {/* Updated: "See all Cars" button colors */}
        <div className="text-center mt-12">
          <Link
            to="/vehicles"
            className="inline-flex items-center space-x-2 bg-gray-200 text-black font-bold py-3 px-8 rounded-full hover:bg-gray-300 transition duration-300"
          >
            <span>See all Cars</span>
            <FaChevronRight />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CarListings;